package fr.frux.feature.treedetail.identity

import fr.frux.feature.treedetail.ImportedTreeSource
import fr.frux.feature.treedetail.TreeDetail

/** Pied du bloc Identité : la dernière correction d'abord, puis l'import, sinon jamais corrigé. */
sealed interface IdentityFooter {
    data class Corrected(
        val authorName: String?,
        val mine: Boolean,
        val atMillis: Long,
    ) : IdentityFooter

    data class Imported(
        val source: ImportedTreeSource,
    ) : IdentityFooter

    data object NeverCorrected : IdentityFooter
}

fun identityFooter(
    tree: TreeDetail,
    correctedByMe: Boolean,
): IdentityFooter {
    val correction = tree.lastCorrection
    val source = tree.importSource
    return when {
        correction != null -> IdentityFooter.Corrected(correction.authorName, correctedByMe, correction.atMillis)
        source != null -> IdentityFooter.Imported(source)
        else -> IdentityFooter.NeverCorrected
    }
}
